import { FileSearch } from "lucide-react";
import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useSendPredefinedMessage } from "~/hooks/chat/use-send-predefined-message";
import { PredefinedTaskCard } from "./predefined-task-card";

interface PredefinedTask {
  key: string;
  icon: React.ReactNode;
  messageKey: string;
}

const predefinedTasks: PredefinedTask[] = [
  {
    key: "findProcedure",
    icon: <FileSearch size={16} />,
    messageKey: "predefinedTasks:findProcedure.message",
  },
];

export const PredefinedTasksGrid: FunctionComponent = () => {
  const { t } = useTranslation();
  const sendPredefinedMessage = useSendPredefinedMessage();

  return (
    <div className="grid grid-cols-1 gap-4 p-4 pt-0">
      {predefinedTasks.map((task, index) => (
        <PredefinedTaskCard
          key={task.key}
          order={index + 1}
          title={t(`predefinedTasks:${task.key}.title`)}
          description={t(`predefinedTasks:${task.key}.description`)}
          icon={task.icon}
          onSend={() => sendPredefinedMessage(t(task.messageKey))}
        />
      ))}
    </div>
  );
};
